// extracted by mini-css-extract-plugin
export default {"container":"Title_container__JhN1x","title":"Title_title__SfecE","logo":"Title_logo__a-iKG"};